import type { FormFields, FormErrors } from '../../formFields'
import { Stack, Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'

import { useDisableSubmit } from '@/components/formUi/hooks/useDisableSubmit'
import { useTexts } from './hooks/useTexts'

interface Props {
  submitting: boolean
  onDiscard: () => void
  onSubmit: () => void
}

export function FormFooter(props: Props) {
  const { onSubmit } = props

  const texts = useTexts()
  const { disableSubmit, submitting } = useDisableSubmit<FormFields, FormErrors>()

  return (
    <Stack
      spacing={2}
      component="footer"
      direction="row"
      paddingTop={4}
      paddingLeft={4}
      paddingRight={4}
      justifyContent="flex-start"
    >
      <LoadingButton
        size="medium"
        type="submit"
        color="primary"
        variant="contained"
        onClick={onSubmit}
        loading={submitting}
        disabled={disableSubmit}
        data-testid="settings-gps-formats-edit-save-button"
        data-trackid="settings-gps-formats-edit-save-button"
      >
        {texts.save}
      </LoadingButton>

      <Button
        type="button"
        size="medium"
        color="primary"
        onClick={props.onDiscard}
        variant="text"
        data-testid="settings-gps-formats-edit-cancel-button"
        data-trackid="settings-gps-formats-edit-cancel-button"
      >
        {texts.cancel}
      </Button>
    </Stack>
  )
}
